import React from 'react';

import ProductList from '../../../../components/PolicySelection/ProductList.component';

const Products = ({ filterProduct, finishSelection }: any) => {
  return (
    <>
      <ProductList
        header_title="Seleccionar producto"
        subtitle="Accedé a tus pagos"
        filter_product={filterProduct}
        finish_selection={finishSelection}
      />
    </>
  );
};

export default Products;
